import * as React from 'react';
import IconBase, { IconBaseProps } from '../components/Icons/IconBase';
const props = {};

const SvgWifiAlert = (allProps: IconBaseProps) => {
  return (
    <IconBase {...allProps}>
      <svg
        width="1em"
        height="1em"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          d="M5.95996 11.284C6.81955 10.4261 7.94999 9.89267 9.15872 9.77469C10.3675 9.65672 11.5797 9.96146 12.589 10.637"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M3.07007 7.822C4.86396 6.17298 7.21029 5.25544 9.64694 5.25007C12.0836 5.2447 14.4339 6.1519 16.2351 7.793"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M0.75 3.885C3.28137 1.85336 6.4304 0.746653 9.67623 0.747926C12.9221 0.749199 16.0702 1.85838 18.6 3.892"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M17.25 20.25C17.3242 20.25 17.3967 20.272 17.4583 20.3132C17.52 20.3544 17.5681 20.413 17.5965 20.4815C17.6248 20.55 17.6323 20.6254 17.6178 20.6982C17.6033 20.7709 17.5676 20.8377 17.5152 20.8902C17.4627 20.9426 17.3959 20.9783 17.3232 20.9928C17.2504 21.0073 17.175 20.9998 17.1065 20.9715C17.038 20.9431 16.9794 20.895 16.9382 20.8333C16.897 20.7717 16.875 20.6992 16.875 20.625C16.875 20.5255 16.9145 20.4302 16.9848 20.3598C17.0552 20.2895 17.1505 20.25 17.25 20.25Z"
          fill="currentColor"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M17.25 18V15"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M23.0631 20.683C23.1983 20.9535 23.2621 21.254 23.2484 21.5561C23.2348 21.8581 23.1441 22.1517 22.9851 22.4089C22.8261 22.666 22.604 22.8783 22.3399 23.0255C22.0758 23.1727 21.7785 23.25 21.4761 23.25H13.0241C12.7217 23.25 12.4244 23.1727 12.1603 23.0255C11.8962 22.8783 11.6741 22.666 11.5151 22.4089C11.3561 22.1517 11.2655 21.8581 11.2518 21.5561C11.2382 21.254 11.3019 20.9535 11.4371 20.683L15.6631 12.231C15.8104 11.9362 16.0369 11.6882 16.3172 11.5149C16.5975 11.3416 16.9205 11.2498 17.2501 11.2498C17.5797 11.2498 17.9027 11.3416 18.183 11.5149C18.4633 11.6882 18.6898 11.9362 18.8371 12.231L23.0631 20.683Z"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </IconBase>
  );
};

SvgWifiAlert.displayName = 'SvgWifiAlert';
export default SvgWifiAlert;
